(() => {
  const activeSections = new WeakMap();
  const initialize = (section) => {
    if (activeSections.has(section)) return;
    let attempts = 0;
    let formObserver;
    let countryObserver;
    let countryAttempted = false;
    const timer = setInterval(() => {
      if (!section.isConnected || ++attempts > 75) {
        clearInterval(timer);
        return;
      }
      const root = section.querySelector('shopify-forms-embed')?.shadowRoot;
      if (!root?.querySelector('form')) return;
      clearInterval(timer);
      const style = document.createElement('style');
      style.textContent = `
        [class*="_formHeader_"] { margin-bottom:var(--vsc-form-intro-gap) !important; }
        h2 { font-size:var(--vsc-current-form-title-size) !important; text-transform:var(--vsc-form-title-case) !important; line-height:1.3 !important; }
        [class*="_formHeader_"] h2 { margin:0 0 var(--vsc-form-header-gap) !important; }
        [class*="_formHeader_"] [class*="_textBody_"] { font-size:var(--vsc-current-form-description-size) !important; text-transform:var(--vsc-form-description-case) !important; line-height:1.55; }
        [class*="_formHeader_"] p { margin:0; text-transform:inherit !important; }
        form { gap:var(--vsc-field-gap) !important; }
        form label,form [class*="_label_"],form [class*="_formFileInput_"] > p { font-size:var(--vsc-current-label-size) !important; text-transform:var(--vsc-label-case) !important; }
        input:not([type="file"]),select,[class*="_selectToggleText_"] { font-size:var(--vsc-current-input-size) !important; text-transform:var(--vsc-input-case) !important; }
        [data-testid="btn-form-submit"],[class*="_formFileInputButton_"] { font-size:var(--vsc-current-button-size) !important; text-transform:var(--vsc-button-case) !important; }
        [class*="_formDisclaimer_"] { font-size:var(--vsc-current-legal-size) !important; text-transform:var(--vsc-legal-case) !important; line-height:1.55; }
        [class*="_formDisclaimer_"] :is(p,a) { font-size:inherit !important; text-transform:inherit !important; }
        [class*="_formFileInputField_"] { border-radius:var(--vsc-field-radius); }
      `;
      if (document.documentElement.classList.contains('voicsky-legacy-contact')) {
        style.textContent += `
          :host { --min-form-width:0px; }
          [data-testid="app-router"], [data-sizing="form-wrapper"] { min-width:0; box-sizing:border-box; }
          form { display:grid !important; grid-template-columns:minmax(0,1fr); gap:var(--vsc-field-gap) !important; }
          input:not([type="file"]), textarea { width:100%; min-width:0; box-sizing:border-box; padding-left:var(--form-field-padding); padding-right:var(--form-field-padding); }
          [class*="_formPhoneInputContainer_"] { width:100%; }
          [class*="_formFileInputLabel_"] { top:0; right:0; bottom:0; left:0; }
          input:not([type="file"]):focus, textarea:focus, [class*="_selectToggle_"]:focus { box-shadow:var(--form-field-border-focused); }
          [class*="_formFileInputField_"]:focus-within { box-shadow:inset 0 0 0 2px var(--forms-accent-color); }
          [data-testid="btn-form-submit"]:focus { outline:2px solid var(--forms-accent-color); outline-offset:2px; }
          [class*="_formSubmitButton_"] { padding-top:var(--button-padding); padding-right:var(--button-padding); padding-bottom:var(--button-padding); padding-left:var(--button-padding); }
        `;
      }
      root.append(style);
      const replaceText = (selector, value) => {
        const element = root.querySelector(selector);
        if (element && value && element.textContent !== value) element.textContent = value;
      };
      const update = () => {
        replaceText('[class*="_formHeader_"] h2', section.dataset.formTitle);
        const dialog = root.querySelector('[role="dialog"][data-sizing="form-wrapper"]');
        if (dialog && section.dataset.formTitle) dialog.setAttribute('aria-label', section.dataset.formTitle);
        replaceText('[data-testid="btn-form-submit"]', section.dataset.submitText);
        const toggle = root.querySelector('button[aria-label^="Country code,"]');
        const phone = root.querySelector('input[name="phone_number"]');
        if (countryAttempted || !toggle || !phone) return;
        countryAttempted = true;
        if (phone.value && !/^\+\d{1,3}\s*$/.test(phone.value)) return;
        if (toggle.getAttribute('aria-label').includes('+852')) return;
        const originalScroll = {left:window.scrollX, top:window.scrollY, behavior:document.documentElement.classList.contains('voicsky-legacy-contact') ? 'auto' : 'instant'};
        const pageScroller = section.closest('.page-wrapper');
        const containerScroll = pageScroller && {left:pageScroller.scrollLeft, top:pageScroller.scrollTop, behavior:originalScroll.behavior};
        const selectHongKong = () => {
          const option = root.querySelector('#select-country-HK');
          if (!option) return;
          countryObserver.disconnect();
          option.click();
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (pageScroller) pageScroller.scrollTo(containerScroll);
            window.scrollTo(originalScroll);
          }));
        };
        countryObserver = new MutationObserver(selectHongKong);
        countryObserver.observe(root, {childList:true, subtree:true});
        toggle.click();
        selectHongKong();
        setTimeout(() => countryObserver?.disconnect(), 3000);
      };
      update();
      formObserver = new MutationObserver(update);
      formObserver.observe(root, {childList:true, subtree:true});
    }, 200);
    activeSections.set(section, () => {
      clearInterval(timer);
      formObserver?.disconnect();
      countryObserver?.disconnect();
      activeSections.delete(section);
    });
  };
  const scan = (target) => {
    if (target.matches?.('.vsource-contact')) initialize(target);
    target.querySelectorAll('.vsource-contact').forEach(initialize);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.vsource-contact').forEach((section) => activeSections.get(section)?.());
  });
})();
